// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormTitle-module__titleText___5BlKz {\n  font-size: 20px;\n  font-family: \"Hiragino Sans\", \"Hiragino Kaku Gothic ProN\", Meiryo, \"sans-serif\";\n  font-weight: 600;\n  color: #444444;\n  max-width: 280px;\n  text-align:left\n}\n\n.FormTitle-module__title___-yR6y {\n  margin-left: 10px;\n}\n\n.FormTitle-module__content___lZscy {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  max-width: 310px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": "FormTitle-module__titleText___5BlKz",
	"title": "FormTitle-module__title___-yR6y",
	"content": "FormTitle-module__content___lZscy"
};
export default ___CSS_LOADER_EXPORT___;
